<script>
import eventBus from "@/shared/eventBus.js";
import { mapState } from "vuex";
export default {
  name: "BuyersHome",
  data() {
    return {
      mousedown: false,
      startX: 0,
      scrollLeft: 0
    };
  },
  computed: {
    ...mapState(["userIsLoged"])
  },
  methods: {
    move(event) {
      if (!this.mousedown) return;
      const x = event.pageX - this.$refs.mainItems.offsetLeft;
      const scroll = x - this.startX;
      this.$refs.mainItems.scrollLeft = this.scrollLeft - scroll;
    },
    stopDragging() {
      this.mousedown = false;
    },
    startDragging(event) {
      this.mousedown = true;
      this.startX = event.pageX - this.$refs.mainItems.offsetLeft;
      this.scrollLeft = this.$refs.mainItems.scrollLeft;
    },
    openSignInModal() {
      if (this.userIsLoged) {
        this.$router.push({
          name: "Profile",
          params: { lang: this.$i18n.locale }
        });
        return;
      }
      let params = {
        modalData: { userIsLoged: this.userIsLoged },
        component: "signInMod"
      };
      eventBus.$emit("openModal", params);
    },
    openRegisterModal() {
      if (this.userIsLoged) {
        this.$router.push({
          name: "Profile",
          params: { lang: this.$i18n.locale }
        });
        return;
      }
      eventBus.$emit("openModal", { component: "chooseRegistrationModal" });
    }
  }
};
</script>
<template>
  <div id="buyers-home">
    <header>
      <h1>
        {{ $t("buyers.header.title") }}
        <span class="red-shift">{{ $t("buyers.header.title2") }}</span>
      </h1>
      <p>{{ $t("buyers.header.text1") }}</p>
      <p>{{ $t("buyers.header.text2") }}</p>

      <p>
        {{ $t("buyers.header.text3") }}
        <span class="underlined">{{ $t("buyers.header.text3Link") }}</span>
      </p>
      <div>
        <RouterLink
          :to="{ name: 'Berza', params: { lang: $i18n.locale } }"
          class="btn dark"
          >{{ $t("buyers.header.linkText") }}</RouterLink
        >
      </div>
      <div class="items">
        <div class="item">
          <h3>{{ $t("buyers.header.items.1.title") }}</h3>
          <p>{{ $t("buyers.header.items.1.text") }}</p>
        </div>
        <div class="item">
          <h3>{{ $t("buyers.header.items.2.title") }}</h3>
          <p>{{ $t("buyers.header.items.2.text") }}</p>
        </div>
        <div class="item">
          <h3>{{ $t("buyers.header.items.3.title") }}</h3>
          <p>{{ $t("buyers.header.items.3.text") }}</p>
        </div>
      </div>
    </header>
    <main>
      <h2>{{ $t("buyers.main.title") }}</h2>
      <h3>{{ $t("buyers.main.subtitle") }}</h3>

      <div
        class="items"
        @mouseup="stopDragging"
        @mousedown="startDragging"
        @mousemove.prevent="move"
        ref="mainItems"
      >
        <div class="item i-1">
          <h3>{{ $t("buyers.main.items.1.title") }}</h3>
          <p>{{ $t("buyers.main.items.1.text") }}</p>
        </div>
        <div class="item i-2">
          <h3>{{ $t("buyers.main.items.2.title") }}</h3>
          <p>{{ $t("buyers.main.items.2.text") }}</p>
        </div>
        <div class="item i-3">
          <h3>{{ $t("buyers.main.items.3.title") }}</h3>
          <p>{{ $t("buyers.main.items.3.text") }}</p>
        </div>
        <div class="item i-4">
          <h3>{{ $t("buyers.main.items.4.title") }}</h3>
          <p>{{ $t("buyers.main.items.4.text") }}</p>
        </div>
      </div>
    </main>
    <section>
      <h2>{{ $t("buyers.register.title") }}</h2>
      <h3>{{ $t("buyers.register.subtitle") }}</h3>
      <div class="btn dark-blue" @click="openRegisterModal">
        {{ $t("buyers.register.button") }}
      </div>
      <span>
        {{ $t("buyers.register.alreadyMember") }}
        <span class="underlined" @click="openSignInModal">
          {{ $t("buyers.register.login") }}
        </span>
      </span>
    </section>
  </div>
</template>
<style scoped lang="scss">
#buyers-home {
  width: 100%;
  text-align: left;
  overflow: hidden;
  header {
    margin: 0;
    font-size: 24px;
    background: url("../../assets/newImges/background_linear.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center 100%;
    padding: 10px 20px;
    h1 {
      text-align: center;
      font-size: 79px;
      color: #333;
      font-weight: 700;
      .red-shift {
        color: #bc4459;
      }
    }
    .items {
      margin-top: 20px;
      display: flex;
      // flex-wrap: wrap;
      flex-direction: column;
      position: relative;
      overflow: auto;
      gap: 10px;
      .item {
        padding: 28px;
        border-radius: 12px;
        background: $gray-blue-500;
      }
    }
    .btn {
      text-decoration: none;
    }
  }
  main {
    background: url("../../assets/newImges/background-elipse.png");
    padding: 20px;
    h2 {
      font-size: 48px;
      font-weight: 500;
    }
    h3 {
      font-size: 26px;
      font-weight: 500;
    }
    .items {
      display: flex;
      flex-direction: column;
      gap: 22px;
      // scroll-behavior: smooth;
      cursor: pointer;
      .item {
        position: relative;
        min-height: 300px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        padding: 28px;
        border-radius: 12px;

        h3 {
          font-size: 25px;
          font-weight: 400;
          margin: 5px 0;
        }
        p {
          font-size: 20px;
        }
        &.i-1 {
          background: url("../../assets/newImges/buyers-page/item-1.png")
            no-repeat center;
          background-size: cover;
        }
        &.i-2 {
          background: url("../../assets/newImges/buyers-page/item-2.png")
            no-repeat center;
          background-size: cover;
        }
        &.i-3 {
          background: url("../../assets/newImges/buyers-page/item-3.png")
            no-repeat center;
          background-size: cover;
        }
        &.i-4 {
          background: url("../../assets/newImges/buyers-page/item-4.png")
            no-repeat center;
          background-size: cover;
        }
      }
    }
  }
  section {
    padding: 60px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    background-color: $light-blue-600;
    min-height: 400px;
    h2 {
      font-size: 36px;
      font-weight: 500;
      margin: 10px;
    }
    h3 {
      font-size: 24px;
      margin: 10px;
      font-weight: 500;
    }
    .btn {
      margin: 10px 0;
    }
    .underlined {
      text-decoration: underline;
      cursor: pointer;
      color: inherit;
    }
  }
  .underlined {
    text-decoration: underline;
  }
  @media screen and (min-width: 768px) {
    padding: 0;
    header {
      background: url("../../assets/newImges/background_linear.png");
      background-size: 100% 50%;
      background-repeat: no-repeat;
      background-position: center 100%;
      padding: 0 16%;

      position: relative;
      // min-height: 95vh;
      h1 {
        // font-size: 100px;
        text-align: left;
      }
      .btn {
        max-width: 300px;
      }
      .items {
        flex-direction: row;
        justify-content: flex-start;
        gap: 25px;
        margin-top: 30px;
        position: relative;
        top: 40px;

        .item {
          // flex: 1;
          flex: 0 0 27%;
        }
      }
    }
    main {
      overflow: visible;
      background: url("../../assets/newImges/background-elipse.png");
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
      padding: 80px 0 80px 16%;
      h2 {
        font-size: 64px;
      }
      h3 {
        font-size: 36px;
      }
      .items {
        flex-direction: row;
        justify-content: flex-start;
        overflow-x: scroll;
        // width: fit-content;
      }
      .item {
        flex: 0 0 30%;
        user-select: none;
      }
    }
    section {
      min-height: 700px;
    }
  }
}
</style>
